import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import React from 'react'

const UnderConstruction = () => {
  const navigate = useNavigate()
  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifySelf: 'center',
          width: 'fit-content',
          height: 'fit-content',
          m: 'auto',
          my: '200px',
          '>p': {
            textAlign: 'center',
          },
        }}
      >
        <Typography sx={{ fontSize: '32px', fontWeight: '600' }}>
          Coming Soon
        </Typography>
        <Typography
          sx={{ mt: 2, fontSize: '22px', color: '#383838', fontWeight: '500' }}
        >
          Some parts of our website is under construction yet.
        </Typography>
        <Typography>Thank you for your patience</Typography>
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 4 }}>
          Go Back
        </Button>
      </Box>
    </Box>
  )
}

export default UnderConstruction
